import NeighbourhoodSubdivisionAdapter from '@/classes/ProjectElementAdapters/NeighbourhoodSubdivisionAdapter'
import BaseClusterGroupAdapter from '@/classes/ProjectElementAdapters/BaseClusterGroupAdapter'

export default class NeighbourhoodSubdivisionClusterGroupAdapter extends BaseClusterGroupAdapter {
  static get ElementAdapter() {
    return NeighbourhoodSubdivisionAdapter
  }
}
